const newsSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://harisharandevgan.com/news/#collection",
      "url": "https://harisharandevgan.com/news/",
      "name": "Harisharan Devgan In The News",
      "description": "Harisharan Devgan, an innovative and humble organic farmer, firmly believes in the holistic growth of the country with his ideology to remain loyal to the nation, cultivating healthier crops, uplifting farming community, and envisioning a future where agriculture and nature complement each other.",
      "about": {
        "@id": "https://harisharandevgan.com/#person"
      }
    },
    {
      "@type": "ItemList",
      "@id": "https://harisharandevgan.com/news/#list",
      "name": "Media Coverage of Harisharan Devgan",
      "itemListElement": [

        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "NewsArticle",
            "headline": "SC to Hear Plea Against Lowering NEET PG Qualifying Percentiles",
            "url": "https://www.timesnownews.com/education/sc-to-hear-plea-against-lowering-neet-pg-qualifying-percentiles-on-feb-13-article-153558236",
            "publisher": {
              "@type": "Organization",
              "name": "Times Now"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "NewsArticle",
            "headline": "Harisharan Devgan Performs Holy Pooja at Srikalahasti",
            "url": "https://www.tribuneindia.com/news/business/harisharan-devgan-performs-holy-pooja-at-srikalahasti-for-indian-farmers-welfare/",
            "publisher": {
              "@type": "Organization",
              "name": "The Tribune"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "NewsArticle",
            "headline": "Assured Water Access Crucial for Small Farmers’ Income Growth",
            "url": "https://www.ptinews.com/press-release/assured-water-access-crucial-for-small-farmers%E2%80%99-income-growth-harisharan-devgan/3200865",
            "publisher": {
              "@type": "Organization",
              "name": "PTI"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 4,
          "item": {
            "@type": "NewsArticle",
            "headline": "NEET-PG Cut-Off Reduced, Supreme Court Seeks Reply",
            "url": "https://www.indiatoday.in/education-today/news/story/neet-pg-cut-off-reduces-sharply-supreme-court-seeks-reply-on-pil-with-hearing-on-friday-2862822-2026-02-04",
            "publisher": {
              "@type": "Organization",
              "name": "India Today"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 5,
          "item": {
            "@type": "NewsArticle",
            "headline": "SC Issues Notice on NEET PG Cut Off Plea",
            "url": "https://www.newindianexpress.com/nation/2026/Feb/04/sc-issues-notice-to-centre-on-plea-against-reduction-of-neet-pg-cut-off",
            "publisher": {
              "@type": "Organization",
              "name": "The New Indian Express"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 6,
          "item": {
            "@type": "NewsArticle",
            "headline": "Harisharan Devgan Changing the Views on Farming",
            "url": "https://www.latestly.com/lifestyle/harisharam-devgan-changing-the-views-on-farming-2469212.html",
            "publisher": {
              "@type": "Organization",
              "name": "Latestly"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 7,
          "item": {
            "@type": "NewsArticle",
            "headline": "Organic Farming Awareness by Harisharan Devgan",
            "url": "https://www.amarujala.com/delhi-ncr/noida/harisharan-devgan-spreading-awareness-about-organic-farming-in-farmers",
            "publisher": {
              "@type": "Organization",
              "name": "Amar Ujala"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 8,
          "item": {
            "@type": "NewsArticle",
            "headline": "IIT Kanpur Ties Up for Hemp Research",
            "url": "https://www.financialexpress.com/jobs-career/education-iit-kanpur-napl-niche-agriculture-and-pharmaceuticals-limited-cannabis-2650777/",
            "publisher": {
              "@type": "Organization",
              "name": "Financial Express"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        },

        {
          "@type": "ListItem",
          "position": 9,
          "item": {
            "@type": "NewsArticle",
            "headline": "IIT Kanpur and NAPL Ink MoU for Hemp Research",
            "url": "https://www.aninews.in/news/business/business/iit-kanpur-inks-down-mou-with-nap-limited-to-achieve-new-milestone-in-hemp-pharmaceuticals-and-bioengineering20220912185534/",
            "publisher": {
              "@type": "Organization",
              "name": "ANI"
            },
            "about": {
              "@id": "https://harisharandevgan.com/#person"
            }
          }
        }

      ]
    },

    {
      "@type": "BreadcrumbList",
      "@id": "https://harisharandevgan.com/news/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://harisharandevgan.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "In The News",
          "item": "https://harisharandevgan.com/news/"
        }
      ]
    }
  ]
};

export default newsSchema;